export default class Menu {
    key: number;
    name: string;
    private active = false;
    total?: number;
    current?: number;

    constructor(key: number, name: string, current?: number, total?: number) {
        this.key = key;
        this.name = name;
        this.total = total;
        this.current = current;
    }

    isNull(a: any): boolean {
        return null != a && undefined != a;
    }

    get bracket(): string {
        if (this.isNull(this.total)) {
            if (this.isNull(this.current)) {
                return `(${this.current}/${this.total})`;
            }
            return `(${this.total})`;
        }
        return null;
    }

    setActive(act: boolean) {
        this.active = act;
    }

    getActive(): boolean {
        return this.active;
    }
}
